<div class="sticky-top">
  <app-back-to-top></app-back-to-top>
</div>
<div>
  <!-- Div to make sticky-top work on ios -->
  <app-static-container
    headerImage="4"
    [capsuleConseilTexte]="'offre-achat.capsule-description' | translate"
    [isLinesGreaterThan4]="true"
  >
    <h1 appFocusOnInit class="titre-page">{{ 'offre-achat.header' | translate }}</h1>

    <h2 class="titre-section">{{ 'offre-achat.content-1.titre' | translate }}</h2>
    <section class="text-content">
      <div class="paragraph-group">
        <p>{{ 'offre-achat.content-1.texte' | translate }}</p>
        <h3>{{ 'offre-achat.content-1.sous-titre-1' | translate }}</h3>
        <p>{{ 'offre-achat.content-1.texte-1' | translate }}</p>
        <h3>{{ 'offre-achat.content-1.sous-titre-2' | translate }}</h3>
        <p>{{ 'offre-achat.content-1.texte-2' | translate }}</p>
      </div>
      <div class="paragraph-group">
        <h2>{{ 'offre-achat.content-2.titre' | translate }}</h2>
        <p class="paragraph-xs" [innerHTML]="'offre-achat.content-2.texte-1' | translate"></p>
        <p class="paragraph-xs" [innerHTML]="'offre-achat.content-2.texte-2' | translate"></p>
        <p class="paragraph-xs" [innerHTML]="'offre-achat.content-2.texte-3' | translate"></p>
        <p class="paragraph-xs" [innerHTML]="'offre-achat.content-2.texte-4' | translate"></p>
      </div>
    </section>
  </app-static-container>
  <app-sub-footer [enableNextStep]="true" [nextStep]="'pret-assurances'"></app-sub-footer>
</div>
